import Vue from 'vue';
import Router from 'vue-router';
import { validateToken } from '@/utils/request';

import Login from '@/views/login.vue'; // 登录页
import index from '../components/index.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history', // 使用 history 模式
  base: process.env.BASE_URL, // 基础路径
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login, meta: { title: '教师-登录' } }, // 根路径重定向到登录页面
    {
      path: '/index',
      component: index,
      meta: { requiresAuth: true, title: '教师端' },
    }, // 根路径重定向到登录页面
    { path: '*', redirect: '/login' },
  ],
});

// 白名单路由
const whiteList = ['/login', '/register', '/reset-password', '/api/auth/captcha'];

// 路由守卫
router.beforeEach(async (to, from, next) => {
  if (whiteList.includes(to.path)) {
    // 如果是白名单路由，直接放行
    next();
  } else {
    try {
      // 验证token
      await validateToken();
      next();
    } catch (error) {
      console.error('Token验证失败:', error);
      next('/login');
    }
  }
});

export default router;
